import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared/ui';
import ClearIcon from 'shared/ui/assets/icons/clear-icon.svg?react';
import { CALCULATOR_KEYBOARDS, CALCULATOR_KEYS } from '../../config';
import { calculatorBetModel } from '../../model';
import cls from './calculator-bet-keyboard.module.scss';

export const CalculatorBetKeyboard = () => {
	const { t } = useTranslation();
	const click = useUnit(calculatorBetModel.keyClicked);

	return (
		<div className={cls.calculatorBetKeyboard}>
			<div className={cls.calculatorBetKeyboardTop}>
				<Button
					variant='secondary'
					size='md'
					onClick={() => click('min')}
				>
					{t('calculator-bet.min')}
				</Button>
				<Button
					size='md'
					variant='secondary'
					onClick={() => click('max')}
				>
					{t('calculator-bet.max')}
				</Button>
			</div>
			<div className={cls.calculatorBetKeyboardBody}>
				{CALCULATOR_KEYBOARDS.map((key) => (
					<Button
						key={key}
						size='md'
						variant='secondary'
						className={cls.calculatorBetKeyboardButton}
						onClick={() => click(key)}
					>
						{key === CALCULATOR_KEYS.delete ? (
							<ClearIcon className={cls.calculatorBetKeyboardDelete} />
						) : (
							key
						)}
					</Button>
				))}
			</div>
		</div>
	);
};
